import 'bootstrap/js/src/offcanvas';
import Rellax from 'rellax';

class Wooncompagnie {
  constructor() {
    this.document = document.querySelector('html');
    this.stampRellaxClass = '.stamp.rellax';
    this.heroRellaxClass = '.hero .rellax';
  }

  init() {
    this.setDocumentClasses();
    
    // Wait for hero slider
    setTimeout(() => {
      this.initHeroRellax();
    }, 200);

    this.initStampRellax();
  }

  setDocumentClasses() {
    setTimeout(() => {
      this.document.classList.add('js');
    }, 200);
  }

  initHeroRellax() {
    /* eslint-disable no-new */
    new Rellax(this.heroRellaxClass);
  }

  initStampRellax() {
    /* eslint-disable no-new */
    new Rellax(this.stampRellaxClass, {
      center: true,
    });
  }

  watchHeroSlider() {
    this.heroSliders.forEach((heroSlider) => {
      heroSlider.slider.on('slideChange', () => {
        this.rellax.refresh();
      });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new Wooncompagnie().init();
});
